<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.createBook')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.createBook')}}</div>
                        <button class="btn btn-primary float-right" @click="saveBook()">{{$t('button.save')}}</button>
                    </div>
                    <div class="card-body">
                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.book.tabBasicInformation')" active>
                                <div class="row">

                                    <div class="col-md-3 col-sm-4">
                                        <div class="form-group">
                                            <label>{{$t('form.book.photo')}}</label>
                                            <vue-dropzone class="m-0 p-0" ref="myVueDropzone" id="dropzone"
                                                :options="dropzoneOptions" @vdropzone-success="profileUploaded"
                                                @vdropzone-processing="isLoading=true" :useCustomSlot="true">
                                                <img width="100%" :src="image" style="cursor:pointer">
                                            </vue-dropzone>
                                        </div>
                                    </div>

                                    <div class="col-md-9 col-sm-8">

                                        <div class="form-group">
                                            <label for="TitleField">{{$t('form.book.title')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="TitleField" class="form-control"
                                                v-model.trim="$v.book.Title.$model"
                                                :class="{ 'is-invalid': $v.book.Title.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Title.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Title.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Title.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="AuthorField">{{$t('form.book.author')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="AuthorField" class="form-control"
                                                v-model.trim="$v.book.Author.$model"
                                                :class="{ 'is-invalid': $v.book.Author.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Author.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Author.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Author.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="PublisherField">{{$t('form.book.publisher')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="PublisherField" class="form-control"
                                                v-model.trim="$v.book.Publisher.$model"
                                                :class="{ 'is-invalid': $v.book.Publisher.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Publisher.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Publisher.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Publisher.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="EditionField">{{$t('form.book.edition')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="EditionField" type="text"  v-model="book.Edition"
                                                class="form-control" v-model.trim="$v.book.Edition.$model"
                                                :class="{ 'is-invalid': $v.book.Edition.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Edition.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Edition.numeric">
                                                {{$t('form.validation.numbersAllowed')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Edition.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Edition.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="YearField">{{$t('form.book.year')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="YearField" type="text" maxlength="4" class="form-control"
                                                v-model.trim="$v.book.Year.$model"
                                                :class="{ 'is-invalid': $v.book.Year.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Year.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Year.numeric">
                                                {{$t('form.validation.numbersAllowed')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Year.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Year.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="ISBNField">{{$t('form.book.ISBN')}}<span
                                                    class="text-danger">*</span></label>
                                            <input v-model="book.ISBN" id="ISBNField" class="form-control"
                                                v-model.trim="$v.book.ISBN.$model"
                                                :class="{ 'is-invalid': $v.book.ISBN.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.ISBN.required">
                                                {{$t('form.validation.required')}}</div>

                                            <div class="invalid-feedback" v-if="!$v.book.ISBN.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.ISBN.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </b-tab>
                            
                            <b-tab :title="$t('form.book.tabAddCourse')">
                                <div class="row">
                                    <div class="col-sm-7 col-md-8">
                                        <div class="table-responsive p-0">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <th>{{$t('form.book.courses')}}</th>
                                                    <th class="text-right">{{$t('form.book.action')}}</th>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(course, index) in selectedCourses" v-bind:key="index">
                                                        <td>{{`${course.CourseCode} - ${course.CourseTitle}`}}</td>

                                                        <td class="text-right">
                                                            <a role="button" style="color:red; cursor:pointer;"
                                                                @click="removeCourse(index)">
                                                                <i class="fa fa-times"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-sm-5 col-md-4">
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="search"
                                                :placeholder="$t('form.book.searchCourse')" v-model="courseTitle"
                                                v-on:keyup="searchCourse">
                                            <div class="input-group-append">
                                                <span class="input-group-text" v-on:click="clear()"
                                                    style="color:red;cursor:pointer;">
                                                    <i class="fa fa-times"></i>
                                                </span>
                                            </div>
                                        </div>

                                        <li class="list-group-item searchCourseBackground" @click="addCourse(course)"
                                            v-for="(course,index) in courses" :key="index" style="cursor: pointer">
                                            {{`${course.CourseCode} - ${course.CourseTitle}`}}
                                        </li>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";

    import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha,
        numeric
    } from "vuelidate/lib/validators";

    export default {
        props: ["permissions"],

        components: {
            vueDropzone: vue2Dropzone
        },

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                image: '/images/no-image.png',

                dropzoneOptions: {
                    url: "/api/books/cover-image",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150,
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    maxFiles: 1
                },

                book: {
                    Title: null,
                    Author: null,
                    Publisher: null,
                    Edition: null,
                    ISBN: null,
                    Year: null,
                    Cover: null,
                    OnStock: null
                },

                courseTitle: '',
                courses: [],
                selectedCourses: [],
            }
        },

        validations: {
            book: {
                Title: {
                    required,
                    maxLength: maxLength(255)
                },
                Publisher: {
                    required,
                    maxLength: maxLength(255)
                },
                Author: {
                    required,
                    maxLength: maxLength(255)
                },
                Edition: {
                    required,
                    maxLength: maxLength(255)
                },
                Year: {
                    required,
                    numeric,
                    maxLength: maxLength(4)
                },
                ISBN: {
                    required,
                    maxLength: maxLength(255)
                }
            }
        },

        mounted() {
            if (!this.permissions.createBooks) {
                this.$router.push("/");
                return;
            }
        },

        methods: {

            profileUploaded(file, response) {
                this.isLoading = false;
                this.book.Cover = response.filename;
            },

            searchCourse() {
                if (this.courseTitle == '') {
                    this.clear();
                    return;
                }

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios
                    .get(`/api/courses?title=${this.courseTitle}`, {
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.courses = response.data.data.data;
                    });
            },

            addCourse(course) {
                // check if course already assigned or not
                let found = this.selectedCourses.find(c => c.ID == course.ID);

                if (found) {
                    alert('Course already assigned, try different one.');
                    return;
                }

                this.selectedCourses.push({
                    ID: course.ID,
                    CourseTitle: course.CourseTitle,
                    CourseCode: course.CourseCode,
                });

                this.clear();
            },

            removeCourse(index) {
                if (confirm(this.$t('form.validation.delete')) === true) {
                    this.selectedCourses.splice(index, 1);
                }
            },

            clear() {
                this.courseTitle = '';
                this.courses = [];
            },

            saveBook() {
                this.$v.$touch();

                if (this.$v.$invalid) {
        
                     let errorMsg = '';
                      if(this.$v.book.Title.$error){
                            errorMsg = 'Title';
                      }

                    if(this.$v.book.Author.$error){
                            errorMsg = errorMsg ? errorMsg +", Author": "Author";
                      }

                    if(this.$v.book.Publisher.$error){
                            errorMsg = errorMsg ? errorMsg +", Publisher": "Publisher";
                      }

                    if(this.$v.book.Edition.$error){
                            errorMsg = errorMsg ? errorMsg +", Edition": "Edition";
                      }

                    if(this.$v.book.Year.$error){
                            errorMsg = errorMsg ? errorMsg +", Year": "Year";
                      }

                     if(this.$v.book.ISBN.$error){
                            errorMsg = errorMsg ? errorMsg +", ISBN": "ISBN";
                      }

                 


                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return; 

                }

                let formData = new FormData();

                formData.append('Cover', this.book.Cover);
                formData.append('Title', this.book.Title);
                formData.append('Author', this.book.Author);
                formData.append('Publisher', this.book.Publisher);
                formData.append('Edition', this.book.Edition);
                formData.append('ISBN', this.book.ISBN);
                formData.append('Year', this.book.Year);

                this.selectedCourses.map(course => formData.append("courses[]", JSON.stringify(course)));

                this.isLoading = true;

                axios
                    .post("/api/books", formData)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.message) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'BookIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;

                        if (error.response.data)
                            this.showAlert('danger', error.response.data.message);
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>

<style scoped>
    .searchCourseBackground:hover {
        background: #eee;
    }

</style>
